import { render, staticRenderFns } from "./ClassDetail.vue?vue&type=template&id=5adb899b&scoped=true"
import script from "./ClassDetail.vue?vue&type=script&lang=js"
export * from "./ClassDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassDetail.vue?vue&type=style&index=0&id=5adb899b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb899b",
  null
  
)

export default component.exports